/**
 * Post Highlights
 */

import React from "react"
import { kebabCase } from "lodash"
import { Link } from "gatsby"
import CopyLinkButton from "./copy-link-button"
import EventsCard from "./events-card"
import NewsCard from "./news-card"

const PostHighlights = ({ props }) => {
  const { heading, primaryLink, secondaryLink, category, posts, type, limit } = props
  let articles = []
  articles = category?.posts?.nodes ? articles.concat(category?.posts?.nodes) : articles
  articles = category?.events?.nodes ? articles.concat(category?.events?.nodes) : articles
  articles = posts ? articles.concat(posts) : articles

  articles?.sort((a, b) => {
    if (!a?.date && !b?.date) return 0
    if (!a?.date) return 1
    if (!b?.date) return -1
    const dateA = new Date(a.date)
    const dateB = new Date(b.date)
    return dateB - dateA
  })

  if (type === "category" && limit) {
    articles = articles?.slice(0, limit)
  }

  return (
    <>
      {articles?.length ? (
        <section
          key={props.heading || props}
          className="section relative transparent p-section-half"
        >
          <div className="container grid gap-8 2xl:gap-12">
            <div className="">
              <div className="group-copy-link group">
                {heading ? (
                  <>
                    <h2
                      className="anchor-heading mb-4 max-w-2xl"
                      id={kebabCase(heading).replace(/[0-9]/g, "")}
                    >
                      {heading}
                    </h2>
                    <CopyLinkButton heading={heading} />
                  </>
                ) : props.includeInStickyMenu?.menuTitle ? (
                  <div
                    id={kebabCase(props.includeInStickyMenu.menuTitle) || ""}
                  >
                    <CopyLinkButton
                      heading={props.includeInStickyMenu.menuTitle}
                    />
                  </div>
                ) : null}
              </div>
            </div>
            <div className="">
              <ul
                className={`grid gap-8 lg:gap-8 2xl:gap-12 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4`}
              >
                {articles?.map(article => {
                  const nodeType = article?.nodeType
                  return (
                    <>
                      {article ? (
                        <li
                          key={article.title}
                          className={`max-w-xs sm:max-w-none`}
                        >
                          {nodeType === "Event" ? (
                            <EventsCard props={article} includeNodeType />
                          ) : nodeType === "Post" ? (
                            <NewsCard props={article} includeNodeType />
                          ) : null}
                        </li>
                      ) : null}
                    </>
                  )
                })}
              </ul>
            </div>
            {primaryLink || secondaryLink ? (
              <div>
                {secondaryLink ? (
                  <Link
                    to={secondaryLink.url}
                    target={secondaryLink.target}
                    className="btn btn-gray mr-4"
                  >
                    {secondaryLink.title}
                  </Link>
                ) : null}
                {primaryLink ? (
                  <Link
                    to={primaryLink.url}
                    target={primaryLink.target}
                    className="btn btn-blue"
                  >
                    {primaryLink.title}
                  </Link>
                ) : null}
              </div>
            ) : null}
          </div>
        </section>
      ) : null}
    </>
  )
}
export default PostHighlights
